
export default function getValue(payload, type) {

  if (!payload || !type) return;

  const {
    typeOfStyle,
    styling,
    windowWidth,
  } = payload;


  if (windowWidth && styling && styling[typeOfStyle] && windowWidth) {

    if (windowWidth === '37_5' && styling[typeOfStyle][windowWidth] && styling[typeOfStyle][windowWidth][type]) {
      return styling[typeOfStyle][windowWidth][type];
    }
    if ((windowWidth === '76_8' || windowWidth === '37_5') && styling && styling[typeOfStyle]['76_8'] && styling[typeOfStyle]['76_8'][type]) {
      return styling[typeOfStyle]['76_8'][type];
    }
  }

  if (styling && styling[typeOfStyle] && styling[typeOfStyle]['0'] && styling[typeOfStyle]['0'][type]) {
    return styling[typeOfStyle]['0'][type];
  } 

  return;

}
